import { DispatchMethod } from '../index';

export const setTourInfo = (skippedTour?: Date, completedTour?: Date) => (dispatch: DispatchMethod) => {
  dispatch({
    type: 'SET_TOUR_INFO',
    payload: { completedTour, skippedTour }
  });
};
